/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedXenialCatalogs } from '../../models/paginated-xenial-catalogs';

export interface XenialCatalogsGet$Params {
  'Active-Tenant-Identifier': string;
  catalogType?: string;
  size?: string;
  start?: string;
}

export function xenialCatalogsGet(http: HttpClient, rootUrl: string, params: XenialCatalogsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedXenialCatalogs>> {
  const rb = new RequestBuilder(rootUrl, xenialCatalogsGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('catalogType', params.catalogType, {});
    rb.query('size', params.size, {});
    rb.query('start', params.start, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedXenialCatalogs>;
    })
  );
}

xenialCatalogsGet.PATH = '/xenial/catalogs';
